export default "__VITE_ASSET__e5c923e4__"